import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";

import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "./http.service";
import { Observable } from "rxjs";
import { StoreHelper } from "../helpers/store.helper";
import { AuthService } from "../../auth/auth.service";
import { environment } from '../../../environments/environment';
import { MessageModalComponent } from "../message-modal/message-modal.component";

const STILL_LOADING_DELAY_MS = 5000;
const LOADING_PROBLEM_DELAY_MS = 5000;


@Injectable()
export class ControllerService {
  private step: number = -1;
  private duration = 0;

  private page = 0;
  private progress = [];

  private steps = [];
  private retrying = false

  private linkCopiedValue = false

  private contentCache = {}

  // true when content from library is loaded. used
  // to indicate the < CONTENT LIBRARY button.
  private library = null;
  private libraryContents = []
  private allContents = []

  private currentRoute = "";

  private pageObservers;

  private clickedNext = false

  private hcontent_id = "";

  private loaded = false;

  private errorMessage = ''

  private clients = [];
  private codes = [];

  private innerWrapper

  private contentFilter = ''

  private clientFilter = ''

  private codeFilter = ''

  private activationCode = ''

  private haveCompletedATraining = false
  private haveIncompleteTraining = false

  private afterRewind = false


  private libraryTheme = ''

  previewing = false;

  private tempData = null
  private temp = {}

  reflections = {}
  actions = []
  actionsType = ''
  actionsSendgridTemplateId = ''

  selectedActions = []
  private renderer: Renderer2;

  private loading = false;
  private loadingText = 'Loading...';
  private stillLoadingTimer: any = null;
  private loadingProblemTimer: any = null;
  private problemModalOpen = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private httpService: HttpService,
    private authService: AuthService,
    private modalService: NgbModal,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);

    // controller needs to listen
    this.router.events.subscribe((val) => {

      this.route.queryParams.subscribe((params: Params) => {
        if (params.page && params.page != this.page) {
          this.page = params.page;
        }

        if (params.step) {
          this.setStep(params.step);
          this.currentRoute = this.steps[this.step].route;
        }
      });

    })

    // then these guys also need to be notified.
    // clearly this is not the right way to do it.
    this.pageObservers = new Observable((observer) => {
      this.router.events.subscribe((val) => {
        const qp = this.route.queryParams.subscribe((params: Params) => {
          if (params.page && params.page != this.page) {
            this.page = params.page;
          }

          if (params.step) {
            this.setStep(params.step);
            this.currentRoute = this.steps[this.step].route;
          }

          observer.next(this.page)
        });
        qp.unsubscribe()
      });
    });
  }

  isSuper(){
    return this.authService.isSuper()
  }

  setInnerWrapper(wrapper) {
    this.innerWrapper = wrapper;
  }

  shiftContainerToTop() {
    this.innerWrapper.nativeElement.classList.add("shift-content-to-top");
  }

  shiftContainerToMiddle() {
    this.innerWrapper.nativeElement.classList.remove("shift-content-to-top");
  }

  redirectToSignIn() {
    StoreHelper.clearUser();
    this.router.navigate(["/signin"]);
  }

  isEducation(){
    return this.authService.isEducation()
  }

  setCodes(codes) {
    this.codes = codes;
  }

  getCodes(){
    return this.codes
  }

  setClients(clients) {
    this.clients = clients;
  }

  getClients(){
    return this.clients
  }

  setLibraryTheme(theme:string){
    this.libraryTheme = theme
  }

  getLibraryTheme(){
    return this.libraryTheme
  }

  getClientKind(clientId){
    const client = this.clients.find(
      ({ id }) => id == clientId
    )
    return client.kind
  }
  getClientId(clientParam) {

    if (this.clients.length == 0) {
      // return from user.
      return StoreHelper.getCurrentUser().client_id;
    }

    const client = this.clients.find(
      ({ name }) => this.getClientNameAsParam(name) == clientParam
    );

    if (client) {
      return client.id;
    }

    return -1;
  }

  getCode(findCode) {
    return this.codes.find(({ code }) => findCode == code);
  }

  getClientName( clientId ){
    const client = this.clients.find(
      ({ id }) => id == clientId
    )

    if( !client ){
      return ''
    }

    return client.name
  }

  getClientExpiry( clientId ){
    return this.clients.find( ({ id }) => id == clientId).contract_end
  }

  getUserGuideURL( code ){
    const url = this.httpService.getBaseUrl() + 'guide/downloadPdf/' + code;
    return url
  }

  async getGovernorsReportUrl( code ){
    const token = await this.authService.getValidToken()
    const url = this.httpService.getBaseUrl() + 'report/governors/' + code + '?token=' + token;
    return url
  }

  async getDownloadFeedbackUrl( clientId ){
    const token = await this.authService.getValidToken()
    const url = 'feedback/download'+ '?clientId=' + clientId + '&token=' + token;
    return url
  }

  async getDownloadFeedbackAllUrl(){
    const token = await this.authService.getValidToken()
    const url = 'feedback/feedbackAll'+ '?token=' + token;
    return url
  }

  getClientNameAsParam(name) {
    return name.replaceAll(" ", "");
  }

  getLoaded() {
    return this.loaded;
  }

  getLoading() {
    return this.loading;
  }

  getLoadingText() {
    return this.loadingText;
  }

  toggleLoading(isLoading: boolean) {
    clearTimeout(this.stillLoadingTimer);
    clearTimeout(this.loadingProblemTimer);

    this.loading = isLoading;
    this.loadingText = 'Loading...';

    if (!isLoading) {
      this.renderer.removeClass(document.body, 'loading');
      return;
    }

    this.renderer.addClass(document.body, 'loading');

    this.stillLoadingTimer = setTimeout(() => {
      this.loadingText = 'Still loading...';
    }, STILL_LOADING_DELAY_MS);

    this.loadingProblemTimer = setTimeout(() => {
      this.toggleLoading(false);

      // Don't stack a second "Problem loading" modal on top of one the learner
      // hasn't dismissed yet (e.g. a retry triggers another load that also stalls).
      if (this.problemModalOpen) {
        return;
      }
      this.problemModalOpen = true;

      const modalRef = this.modalService.open(MessageModalComponent);
      modalRef.componentInstance.title = 'Problem loading';
      modalRef.componentInstance.messageTestId = 'error-banner';
      modalRef.componentInstance.message = `If the page is not loading, please refresh the page.
If the issue persists, contact our Product Support team <a target="_blank" href="https://raretechnology.hipporello.net/desk/form/20d9c116305d46b48592e61fc2f4f3e1">here</a>.`;
      modalRef.result.then(
        () => { this.problemModalOpen = false; },
        () => { this.problemModalOpen = false; },
      );
    }, STILL_LOADING_DELAY_MS + LOADING_PROBLEM_DELAY_MS);
  }

  getPageObservers() {
    return this.pageObservers;
  }

  getPage() {
    return parseInt(this.page + "");
  }

  getSteps() {
    return this.steps;
  }

  getStepItem() {
    return this.steps[this.step];
  }

  getLibraryContents() {
    return this.libraryContents;
  }

  isLibrary(){
    return this.library
  }

  linkCopied(){
    return this.linkCopiedValue
  }

  async copyLink(){
    const url = `https://${window.location.hostname}/start?contentLibraryId=${this.getContentId()}`

    const input = document.createElement('input');
    input.value = url;
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Fallback copy failed:', err);
    }
    document.body.removeChild(input);


    this.linkCopiedValue = true
    window.setTimeout( ()=> {
      this.linkCopiedValue = false
    }, 5000)
  }

  flushLibrary(){
    this.allContents = this.allContents.filter( ({type}) => type !== 'library')
    this.contentCache = {}
  }
  async fetchContents(contents){

    try {
      const promises = contents.map(async (content) => {
        let contentData = this.contentCache[content.hcontent_id];

        if (!contentData) {
          try {
            const url = environment.audioBaseDir + '/' + content.s3url.split('amazonaws.com/')[1]
            const response = await fetch(url)
            contentData = await response.json()

            this.contentCache[content.hcontent_id] = {...contentData, ...content};
          } catch (error) {
            console.error(`Error fetching content for ${content.hcontent_id}:`, error);
            // throw error;
          }
        }

        return {
          ...content,
          ...contentData
        };
      });

      const allContent : any[] = [...await Promise.all(promises)]

      for( const content of allContent ){
        const existing = this.allContents.find( ({ hcontent_id }) => hcontent_id == content.hcontent_id )
        if( !existing ){
          this.allContents.push(content);
        }
      }

    } catch (error) {
      console.error('Error processing contents:', error);
      throw error;
    }
  }

  getIntroVideoId ( ){

    const references = this.steps.find( ({ route }) => route == '/intro-video' )

    if( references ){
      return references.section.components[0].properties.vimeoId
    }
    return 0
  }

  getReferencePageForVideoId (videoId) {

    const references =  this.allContents.find( ({ metadata }) => {
      return metadata && metadata.properties && metadata.properties.type == 'references'
    })

    if( references ){
      const page = references.sections[0].components.find( ({ properties }) => {
        if( properties.vimeoId == videoId ){
           return true
        }
      })
      if( !page ){
        console.error("No references found for id " + videoId)
      }
      return page
    }
    return false
  }

  setupLibrary(open, code = null) {
    this.loaded = true;

    this.libraryContents = this.allContents
      .filter(
        (content) =>
          content.metadata &&
          content.metadata.properties &&
          content.metadata.properties.type == "library"
      )

    if (open) {
      this.goToLibrary();
    }
  }

  setDoneTraining(){
    this.library = true
  }

  getContentId(){
    return this.hcontent_id
  }

  goToLibrary() {

    this.router.navigate(["library"]);
  }

  async initFromRoute() {
    const promise = new Promise<void>((resolve, reject) => {
      const listener = this.route.queryParams.subscribe((params: Params) => {
        if (params.page && params.page != this.page) {
          this.page = params.page;
        }

        if (params.step) {
          this.setStep(params.step);

          const step = this.steps[this.step]

          this.currentRoute = step ? step.route : null;
        }

        resolve();
      });
    });
    return promise;
  }

  loadActivationCode(code) {}

  countWordsInElements(container) {
    if (!container.elements) {
      return 0;
    }
    return container.elements.reduce((wordAcc, element) => {
      wordAcc += element.value ? element.value.toString().split(" ").length : 0;
      return wordAcc;
    }, 0);
  }

  async storeTempData(id, data) {
    if( !this.tempData ){
      this.tempData = {}
    }
    if( id ){
      this.tempData[id] = data
    }
    if( this.previewing ){
      return
    }
    if( id == null && data == null  ){
      this.tempData = null
      this.temp[this.hcontent_id] = null
      await this.httpService.postAsync("user/saveTempData", { data: null });
      return
    }

    this.temp[this.hcontent_id] = this.tempData
    const d = JSON.stringify(this.temp)
    await this.httpService.postAsync("user/saveTempData", { data: d });
  }

  async getTempData(id, defaultReturn = {} ) {

    if( this.previewing ){
      return this.tempData && this.tempData[id]  ? this.tempData[id] : []
    }

    if( this.tempData == null ){
      const d: any = await this.httpService.getAsync("user/getTempData");
      const data = this.decodeMaybe(d.data)
      this.temp = d.data ? JSON.parse(data) : {}
      this.tempData = this.temp[this.hcontent_id]
    }
    return this.tempData && this.tempData[id] ? this.tempData[id] : defaultReturn
  }

  decodeMaybe( data ){
    try{
      const decoded = atob(data)
      return decoded
    }catch( e ){
      return data
    }
  }

  async nukeTempData() {
    await this.storeTempData(null, null)
  }

  setSelectedActions(actions) {
    this.selectedActions = actions;
  }

  getSelectedActions(){
    return this.selectedActions
  }

  getBiasResults(ratings) {
    const promise = new Promise<any>((resolve, reject) => {
      this.httpService.post("rate/doRatings", { ratings }).subscribe((results) => {
        resolve(results);
      });
    });
    return promise;
  }



  loadHemisphere(hcontent_id, previewing, library, json = null) {

    this.hcontent_id = hcontent_id;

    const hemisphere = json != null ? json : this.allContents.find( ({ hcontent_id :id }) => id == hcontent_id);

    console.log('Loading content ', hemisphere, hcontent_id, this.allContents)
    this.currentRoute = ''

    this.tempData = null

    this.library = library;

    this.previewing = previewing;

    const AVG_WORDS_PER_MINUTE = 180;
    const AVG_WORDS_PER_SECOND = AVG_WORDS_PER_MINUTE / 60;

    let componentId = -1;

    this.steps = hemisphere.sections.reduce((acc, section : any) => {
      if (section.components.length == 0) {
        acc.push({
          route: section.route,
          componentId: componentId++,
          section,
        });
        return acc;
      }


      if( section.route == '/actions' || section.route == '/reminders' ){
        // set up actions
        const type = section.properties.type
        const sendgridTemplateId = section.properties.sendgridTemplateId
        const actions : any = section.components.map( (component) => {
            if( component.properties.summary ){
              return
            }

            const haveHelperImage = component.elements.find( ({type}) => type == 'action-button-example') != null

            const actionObject = {
            title: component.elements.find( ({type}) => type === 'header' ).value,
            commentParagraphs: component.elements.filter( ({type}) => type === 'p' ),
            comment : component.elements.filter( ({type}) => type === 'p' ).map( ({value}) => `<p>${value}</p>`).join(''),
            emailComment : component.elements.filter( ({type}) => type === 'email-p' ).map( ({value}) => `<p>${value}</p>`).join(''),

            helperImage: haveHelperImage ? (type == 'reminders' ? 'reminders-you-want-to-keep.png' : 'actions-help-button.png') : '',
            image: component.properties.image
          }

          return actionObject

        }).filter( ({comment}) => !!comment)
        this.setActions( sendgridTemplateId, type, actions )
      }

      section.components.reduce((acc, component, index) => {
        componentId++;

        let duration = 0;

        if (component.type == "video" || component.type == "bubbles") {
          let [minutes, seconds] = component.properties.duration ? component.properties.duration.split(":") : [0,0]
          duration = parseInt(minutes) * 60 + parseInt(seconds);
        }

        // if there are subcomponents, we need to add each one
        if (component.subComponents && component.subComponents.length > 0) {
          component.subComponents.reduce((acc, subComponent, subIndex) => {
            duration = this.countWordsInElements(subComponent);

            if (subComponent.type == "rating-component") {
              let [minutes, seconds] =
                subComponent.properties.duration.split(":");
              if (!minutes) {
                minutes = 0;
              }
              duration = parseInt(minutes) * 60 + parseInt(seconds);
            }

            acc.push({
              route: section.route,
              index,
              subIndex,
              section,
              component,
              subComponent,
              componentId,
              duration,
            });

            return acc;
          }, acc);
        }

        // if there are no subcomponents, it's just the component and its elements
        // we are adding.
        if (!component.subComponents) {
          const words = this.countWordsInElements(component);
          duration += Math.round(words / AVG_WORDS_PER_SECOND);

          acc.push({
            route: section.route,
            section,
            component,
            componentId,
            index,
            duration,
          });
        }

        return acc;
      }, acc);

      return acc;
    }, []);

    // go through each step and add description

    this.steps = this.steps.map((step) => {
      let description = "";

      if (
        step.component &&
        step.component.elements &&
        step.component.elements[0] &&
        step.component.elements[0].value
      ) {
        description = step.component.elements[0].value
          .split(" ")
          .slice(0, 10)
          .join(" ");
      }

      return {
        ...step,
        description,
      };
    });

    if (library) {
      this.steps.push({
        route: "complete-content-library",
        section: [],
        component: "",
        componentId: 0,
        index: 0,
        duration: 0,
      });
    }

    this.progress = this.steps.map(({ duration }) =>
      isNaN(duration) ? 0 : duration
    );

    this.duration = this.progress.reduce((acc, it) => {
      return (acc += it);
    }, 0);

    this.loaded = true;
  }

  getSectionProperties() {
    return this.steps[this.step].section.properties
      ? this.steps[this.step].section.properties
      : {};
  }

  fixList(type, listitem, elements) {
    const listAt = elements.findIndex((it) => it.type == listitem);
    const listitems = elements.filter((it) => it.type == listitem);

    if (listitems.length > 0) {
      const list = {
        type,
        elements: listitems,
      };
      elements = elements.filter((it) => it.type != listitem);
      elements.splice(listAt, 0, list);
    }
    return elements;
  }

  getSectionComponents() {
    let components = this.steps[this.step].section.components
      ? this.steps[this.step].section.components
      : [];

    // fix up list items, they don't have a parent container to KISS, so we make one here.
    const fixedComponents = components.reduce((comps, component) => {
      let elements = component.elements ? component.elements : [];

      elements = this.fixList("ul", "listitem", elements);
      elements = this.fixList("parts", "whatsnext-item", elements);
      elements = this.fixList("stats", "stats-item", elements);
      elements = this.fixList("answers", "answer-item", elements);

      comps.push({
        ...component,
        elements,
      });

      return comps;
    }, []);

    return fixedComponents;
  }

  rewind(steps) {
    this.step = this.getStep() - parseInt(steps);
  }

  fastforward(steps) {
    this.step = this.getStep() + parseInt(steps);
  }

  async forwardComponent() {
    await this.gotoNextComponent(false);
  }

  async backComponent() {
    await this.gotoNextComponent(true);
  }

  setStep(step) {
    this.step = parseInt(step);
  }
  getStep() {
    return parseInt(this.step + "");
  }

  isNextNewComponent() {
    const next = this.steps[this.step + 1];
    if (!next) {
      return true;
    }

    return next.index == 0;
  }


  async gotoNextSection(){


    const steps = this.steps.slice(this.step+1)



    const index = steps.findIndex( ({index}) => index === 0 )


    const nextStep = this.step + index


    this.step = nextStep

    await this.next()

  }

  async gotoNextComponent(back) {
    const step = this.getStep();

    const currentComponentId = this.steps[step].componentId;


    const next = back ? currentComponentId - 1 : currentComponentId + 1;

    const nextStep = this.steps.findIndex(
      ({ componentId }) => componentId == next
    );

    if (back) {
      this.step = nextStep + 1;
      await this.back();
    } else {
      this.step = nextStep - 1;
      await this.next();
    }
  }

  resume(fromStep) {
    if( fromStep == 0 ){
      this.removeCookie("sentActions")
    }
    this.step = fromStep - 1;
    this.next( this.step < 0 ? false : true );
  }

  getAfterRewind(){
    return this.afterRewind
  }

  getErrorMessage(){
    return this.errorMessage
  }

  getRetrying(){
    return this.retrying
  }

  setErrorMessage(message){
    this.errorMessage = message
  }

  async next(resume = false, afterRewind = false, ignoreFailToSaveProgress = false) {

    if( this.clickedNext ){
      return
    }

    this.clickedNext = true

    if( this.errorMessage != '' ){
      this.retrying = true;
      this.setErrorMessage("Retrying..")
    }

    const step = this.step + 1
    const hcontent_id = this.hcontent_id
    const total_steps = this.steps.length - 1

    let success = false

    let alreadySentFeedback = this.getCookie("alreadySentFeedback") === "true"

    if (step == total_steps && !this.library && !alreadySentFeedback) {

      const feedback : any = await this.getTempData("feedback")
      const contentId = this.getContentId()

      let nonce = this.getCookie('anonymousOneTimeSubmit')
      if( !nonce ){
        nonce = this.generateNonce()
        this.setCookie('anonymousOneTimeSubmit', nonce, 5)
      }

      if(!this.previewing && feedback.length && contentId ){
        let res: any  = null
        this.renderer.addClass(document.body, 'loading');
        res = await this.submitFeedback(feedback, contentId, nonce)
        this.renderer.removeClass(document.body, 'loading');
        if( res && res.success ){
            success = true
            this.setCookie("alreadySentFeedback", "true", 5)
        }
      }else{
        success = true
      }
      await this.nukeTempData();
    }else{
      success = true
    }

    if ( success && ( this.library && !this.previewing)  || (!resume && !this.previewing) ) {
      let resp : any = null

      try{
        resp = await this.httpService.postAsync("user/updateProgress", {
          step,
          hcontent_id,
          total_steps,
        });
      }catch(e){
      }
      if( resp && resp.success ){
        success = true
      }else{
        success = false
      }
    }

    this.clickedNext = false

    // after watching a video we ignore any failures to save progress, allow progress
    // and hope that we can save on the next call. if not, at least then they'll have a button
    // to click and not have to re-watch the video.
    if( ignoreFailToSaveProgress === true){
      success = true;
    }


    if( !success ){
      // display retry.

      this.retrying = false
      const message = step == 0 ? "An error occured loading Hemisphere, please wait a moment and refresh the page to try again." : "An error occured saving your progress, please wait a moment and try again."
      this.setErrorMessage(message)
      return false
    }else{
      this.setErrorMessage("")
      this.step++;
    }



    const next = this.steps[this.step];

    if( !next ){
      return
    }

    let page;
    let itemIndex;

    if (next.subIndex != undefined) {
      page = next.subIndex;
      itemIndex = next.index;
    } else {
      page = next.index;
    }

    this.afterRewind = afterRewind

    const nextRoute = next.route;
    const queryParams: Params = { step: this.step, page, itemIndex };

    this.page = page;


    const promise = new Promise<void>((resolve, err) => {
      if (nextRoute != this.currentRoute) {
        this.router
          .navigate([nextRoute], {
            queryParams,
            queryParamsHandling: "merge",
          })
          .then(() => {
            resolve();
          });

        this.currentRoute = nextRoute;
      } else {
        // updates page
        this.router
          .navigate([], {
            relativeTo: this.route,
            queryParams: queryParams,
            queryParamsHandling: "merge",
          })
          .then(() => {
            resolve();
          });
      }
    });



    return promise;
  }

  async back() {
    this.step--;

    const prev = this.steps[this.step];

    let page;
    let itemIndex;

    if (prev.subIndex != undefined) {
      page = prev.subIndex;
      itemIndex = prev.index;
    } else {
      page = prev.index;
    }

    const prevRoute = prev.route;

    this.page = page;

    const queryParams: Params = { step: this.step, page, itemIndex };

    const promise = new Promise<void>((resolve, err) => {
      if (prevRoute != this.currentRoute) {
        this.router
          .navigate([prevRoute], {
            queryParams,
            queryParamsHandling: "merge",
          })
          .then(() => {
            resolve();
          });

        this.currentRoute = prevRoute;
      } else {
        this.router
          .navigate([], {
            relativeTo: this.route,
            queryParams: queryParams,
            queryParamsHandling: "merge",
          })
          .then(() => {
            resolve();
          });
      }
    });

    return promise;
  }

  async submitFeedback(feedback, contentId, nonce, retry = 0){
    try{
        const res: any = await this.httpService.postAsync("feedback/submitFeedback", {feedback, contentId, nonce, retry})
        if( res && res.success ){
            return res
        }else if( res && res.success === false ){
          return res
        }
    }catch( e ){
      if( retry < 3 ){
        await new Promise(resolve => setTimeout(resolve, (retry+1) * 1500));
        return await this.submitFeedback(feedback, contentId, nonce, retry + 1)
      }
    }
    return {success:false}
  }


  generateNonce(length = 80) {
  // Calculate how many bytes we need (2 hex chars per byte)
  const byteLength = Math.ceil(length / 2);
  const array = new Uint8Array(byteLength);

  // Fill array with cryptographically strong random values
  window.crypto.getRandomValues(array);

  // Convert bytes to hex string and trim to exact requested length
  return Array.from(array)
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('')
    .substring(0, length);
}

  setCookie(name: string, value: string, minutes: number) {
    let expires = "";
    if (minutes) {
        const date = new Date();
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    const cookieString = name + "=" + (value || "") + expires + "; path=/";
    document.cookie = cookieString;
  }

  getCookie(name: string) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  removeCookie(name: string) {
    this.setCookie(name, "", -1);
  }


  getClassObject(element, additional) {
    let classes = "";
    if (element && element.properties && element.properties.classes) {
      classes = element.properties.classes;
    }

    const cls = classes
      .split(" ")
      .concat(additional)
      .filter(Boolean)
      .reduce((acc, it) => {
        acc[it] = true;
        return acc;
      }, {});

    return cls;
  }

  // returns progres[step]
  getProgress() {
    // could include progress into video here as well.

    let progress = this.progress.slice(0, this.step).reduce((acc, it) => {
      return (acc += it);
    }, 0);

    if( this.step == this.steps.length -1 ){
      progress = this.duration
    }

    return Math.floor((progress / this.duration) * 100);
  }

  setReflection( question, text ){
    if( !this.reflections ){
      this.reflections = {}
    }
    this.reflections[question] = text
    this.storeTempData('reflections', this.reflections)
  }

  async loadReflections(){
    this.reflections = await this.getTempData('reflections')
  }

  getReflection( question ){
    return this.reflections[question]
  }

  getReflections( ){
    if( this.reflections == null ){
      this.reflections = {}
    }
    return Object.entries( this.reflections )
  }


  setActions( actionsSendgridTemplateId, type, actions ){
    this.actionsType = type
    this.actions = actions
    this.actionsSendgridTemplateId = actionsSendgridTemplateId
  }

  getActions(){
    return {
      type: this.actionsType,
      actions: this.actions,
      sendgridTemplateId: this.actionsSendgridTemplateId
    }
  }

  getPreviewing(){
    return this.previewing
  }

  setPreviewing( to ){
    this.previewing = to
  }

  backToStart(){

    this.clearCurrentRoute()
    this.router.navigate(['/start'])


  }

  clearCurrentRoute(){
    this.currentRoute = null
    this.step = 0
  }

  setContentFilter(filter){
    this.contentFilter = filter
  }

  getContentFilter(){
    return this.contentFilter
  }

  setActivationCode(activationCode){
    this.activationCode = activationCode
  }

  getActivationCode( ){
    return this.activationCode
  }

  setClientFilter( filter ){
    this.clientFilter = filter
  }

  getClientFilter( ){
    return this.clientFilter
  }

  setCodeFilter( filter ){
    this.codeFilter = filter
  }

  getCodeFilter( ){
    return this.codeFilter
  }

  setHaveCompletedATraining( val ){
    this.haveCompletedATraining = val
  }

  getHaveCompletedATraining( ){
    return this.haveCompletedATraining
  }

  setHaveIncompleteTraining( val ){
    this.haveIncompleteTraining = val
  }

  getHaveIncompleteTraining( ){
    return this.haveIncompleteTraining
  }
}
